<template>
    <div class="card animated fadeInUp faster">
        <div class="card-body">
            <div id="present-to-shopper-container"></div>
        </div>
    </div>
</template>

<script>

    import {mapState} from "vuex";

    export default {
        name: "SetupResponseAdyenVoucher",
        methods: {
            handleOnAdditionalDetails: function (state, component) {
                payload = encodeURIComponent(state.data.details.payload);
                document.location.href = this.setupPesponse.data.completeUrl + "?payload=" + payload;
            }
        },
        computed: {
            ...mapState({
                setupResponse: state => state.payment.setupResponse,
            })
        },
        mounted() {
            let configuration = {
                locale: "en_US",
                environment: window.tebex.methods.adyen.environment,
                originKey: window.tebex.methods.adyen.originKey,
                onAdditionalDetails: this.handleOnAdditionalDetails
            };

            this.checkout = new AdyenCheckout(configuration);

            this.checkout.createFromAction(this.setupResponse.data.action).mount("#present-to-shopper-container");
        }
    }

</script>
